import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

export const transactionsTour: TourDef = {
  id: 'transactions',
  steps: [
    { element: a('quick-add'), popover: { title: 'Quick add', description: 'Type it like you would say it: "coffee 4.50 yesterday #cafe". The preview shows exactly what will be saved.' } },
    { element: a('register-filters'), popover: { title: 'Find anything', description: 'Filter by date (financial years included), category, payee, tag or amount, and save the filters you reuse.' } },
    { element: a('register'), popover: { title: 'Keyboard-first register', description: 'J and K move, Enter edits in place, X selects, C categorises, R marks reviewed, D deletes with Undo.' } },
    { element: a('new-transaction'), popover: { title: 'The full editor', description: 'Splits, transfers, receipts and foreign currency live here. Press N from anywhere.' } },
  ],
};
